/**
 * 环境配置
 * 通过 webpack DefinePlugin 注入的环境变量
 */

// 环境类型: 'development' | 'production'
export const NODE_ENV = process.env.NODE_ENV || 'development';

// 部署环境: 'test' | 'prod'
export const DEPLOY_ENV = process.env.DEPLOY_ENV || 'test';

// 是否为开发模式
export const isDev = NODE_ENV === 'development';

// 是否为生产模式
export const isProd = NODE_ENV === 'production';

// 是否为测试环境
export const isTestEnv = DEPLOY_ENV === 'test';

// 是否为正式环境
export const isProdEnv = DEPLOY_ENV === 'prod';

// 基础URL配置
export const BASE_URL = isTestEnv
  ? 'https://ocrdemo.cloud.tencent.com/test'
  : 'https://ocrdemo.cloud.tencent.com';

// 导出环境信息（用于调试）
export const envInfo = {
  NODE_ENV,
  DEPLOY_ENV,
  isDev,
  isProd,
  isTestEnv,
  isProdEnv,
  BASE_URL
};

// 开发环境下打印环境信息
if (isDev) {
  console.log('[ENV Config]', envInfo);
}

export default {
  NODE_ENV,
  DEPLOY_ENV,
  isDev,
  isProd,
  isTestEnv,
  isProdEnv,
  BASE_URL
};
